module.exports = __webpack_public_path__ + "static/img/13.f8604bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/13.png
// module id = TdyH
// module chunks = 0